/********************************************************************
 * global scope js
 *******************************************************************/

/********************************************************************
 * jQuery (document.ready)
 *******************************************************************/

$(document).ready(function() {
	initAnchorScroll();
	initHubspotVexDlg();
	initOverlay();
	initNavigation();
	initSlider('ipconsulting');
	initSlider('associates');
	initLogoSlider();
	// initStatementSlider();
	cardPosition();
	initServiceSlider();
	serviceSlider();
	// initServiceSliderIP();
	serviceSliderInitIP();
	serviceSliderIP();
	initStatements();
	initCaseStudyHeight();
	initCaseStudyScrollbar();
	initSheetSlider();
	serviceCardClick();
	acServiceCardClick();
	acServiceFirstCardClick();
	acServiceDetailCardClick();
	serviceDetailCardClick();
	// serviceBackArrow();
	initFacts();
	initTeamSlider();
	initResizeEvents();
	initFaqSlider();
	initHomeRibbonsScroll();
	initTestimonialSlider();
	initCareerSlider();
	initHubspotForm();
	initWorldMap();
	initOfficeLink();
	initSmoothScroll();
	initSmoothAnchorScroll();
	initSmoothAnchorScrollContact();
	initScrollToService();
	initScrollToCaseStudy();
	initTopBarScrollBehaviour();
	initNavigationScrollBehaviour();
	initImgScroll();
	initStickyNav();
	clickGetInTouchButton();
});